import "./AuthLayoutComponent.scss";
import { FC } from "react";
import AuthLayoutComponentProps from "./AuthLayoutComponentProps";
import AuthInfoComponent from "../../components/authInfo/AuthInfoComponent";

const AuthLayoutComponent: FC<AuthLayoutComponentProps> = ({ children }) => {
    return <div className="auth_layout_component">
        <div className="container">
            <div className="d-flex align-items-center justify-content-center">
                <div className="form-container">
                    {children}
                </div>
            </div>
        </div>
    </div >
}

export default AuthLayoutComponent;